import { Row, Col } from "react-bootstrap";
import {
  LogotypeMalopolska,
  LogotypeUe,
  LogotypeWup,
  LogotypeBelkaPoziom,
} from "wup-module1-base";

function Logotypes() {
  return (
    <div className="logotypes-container">
      <Row className="m-0 justify-content-center">
        <Col xs={12} md={12} className="my-auto">
          <img
            className="logotype"
            src={LogotypeBelkaPoziom}
            alt="Logo MAŁOPOLSKI POCIĄG DO KARIERY"
          />
        </Col>
      </Row>
    </div>
  );
}

export default Logotypes;
